import { Component, Input, OnInit } from '@angular/core';

@Component({
  selector: 'app-complete-race-percent',
  templateUrl: './complete-race-percent.component.html',
  styleUrls: ['./complete-race-percent.component.scss']
})
export class CompleteRacePercentComponent implements OnInit {

  @Input() percent: number;

  constructor() { }

  ngOnInit(): void {
  }

}
